import React from 'react';
import './RadioButtons.css';
interface CheckboxComponentProps {
    disabled?: boolean;
    className?: string;
    radioName: string;
    radioButtonGroup: string;
    onRadioButtonChange: (value: string) => void;
    radioValue?:string;
    radioId?:string,
    defaultChecked?:boolean
}
const RadioButtonComponent: React.FC<CheckboxComponentProps> = ({
    disabled,
    radioName,
    className,
    radioButtonGroup,
    onRadioButtonChange,
    radioValue,
    radioId,
    defaultChecked=false

}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onRadioButtonChange(e.target.value);
    };
    return (
        <div className="custom_radio_button">
            <input
                className={`styled-radio ${className}`}
                type="radio"
                disabled={disabled}
                onChange={handleChange}
                name={radioButtonGroup}
                value={radioValue}
                defaultChecked={defaultChecked}
                id={radioId}
            />&nbsp;
            <label className="radio_button_name_fromparent mb-0">{radioName}</label>
        </div>
    );
};

export default RadioButtonComponent;



